




































export default {
  name: "BaseVideoRangeSlider",
  components: {},
  data: function () {
    return {
      isDragLeft: false,
      isDragRight: false,
      isSoSmallGap: false,
    };
  },
  computed: {
    relativeWidth: function () {
      return (
        ((this.value.finishTime - this.value.startTime) * 100) / this.duration
      );
    },
    leftPosition: function () {
      return (this.value.startTime * 100) / this.duration + "%";
    },
  },
  mounted() {},
  updated() {
    this.isSoSmallGap = this.$refs.rangeGap
      ? this.$refs.rangeGap.getBoundingClientRect().width < 50
      : false;
  },
  props: {
    duration: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onStartDrag(side, event) {
      if (this.disabled) {
        return;
      }
      this.$emit("startDrag", side);
      console.log("start-drag");
      this.isDragLeft = side === "left";
      this.isDragRight = side === "right";
      window.onmousemove = this.moveAt.bind(event);
      window.onmouseup = this.myDragStop.bind(event);
    },
    moveAt(event) {
      event.preventDefault();
      if (this.disabled) {
        return;
      }
      console.log("drag");
      let newTime = 0;
      //min 1 sec
      //TODO if video less than 1 sec
      if (this.isDragLeft) {
        newTime =
          this.value.startTime +
          (event.movementX / this.$refs.gap.offsetWidth) * this.duration;
        newTime = Math.floor(newTime * 100) / 100;
        this.value.startTime =
          newTime < 0
            ? 0
            : newTime > this.value.finishTime - 1
            ? this.value.finishTime - 1
            : newTime;
      } else if (this.isDragRight) {
        newTime =
          this.value.finishTime +
          (event.movementX / this.$refs.gap.offsetWidth) * this.duration;
        newTime = Math.floor(newTime * 100) / 100;
        this.value.finishTime =
          newTime > this.duration
            ? this.duration
            : newTime < this.value.startTime + 1
            ? this.value.startTime + 1
            : newTime;
      }
      this.$emit("changeDuration", newTime);
      console.log(this.value.startTime + "  " + this.value.finishTime);
    },
    myDragStop() {
      if (this.disabled) {
        return;
      }
      console.log("stop-drag");
      window.onmouseup = null;
      this.isDragLeft = false;
      this.isDragRight = false;
      window.onmousemove = null;
      this.$emit("stopDrag", this.value.startTime);
    },
  },
};
